import { Box, Card, Flex, Table, Tbody, Td, Text, Th, Thead, Tr } from "@chakra-ui/react"
import { FC } from "react"
import { formatDate } from "src/utils/helpers"
import { Village } from "../../../../domain/entities/village"
import { DeleteIconButton } from "../../../ui/iconButtons/DeleteIconButton"
import { EditIconButton } from "../../../ui/iconButtons/EditIconButton"

export const VillageListView: FC<{
	list: Village[]
	onUpdate: (village: Village) => void
	onDelete: (village: Village) => void
}> = ({ list, onUpdate, onDelete }) => (
	<>
		<Table size={"sm"} display={{ base: "none", lg: "table" }}>
			<Thead>
				<Tr>
					<Th>Name</Th>
					<Th>Name Gujarati</Th>
					<Th>Taluka</Th>
					<Th>District</Th>
					<Th>State</Th>
					<Th>Country</Th>
					<Th>Created At</Th>
					<Th>Updated At</Th>
					<Th isNumeric>Actions</Th>
				</Tr>
			</Thead>
			<Tbody>
				{list.map((village, i) => (
					<Tr key={i}>
						<Td>{village.name.en}</Td>
						<Td>{village.name.gu}</Td>
						<Td>
							<Text fontWeight={500}>{village.taluka?.name?.en}</Text>
							<Text>{village.taluka?.name.gu}</Text>
						</Td>
						<Td>
							<Text fontWeight={500}>
								{village.taluka?.district?.name?.en}
							</Text>
							<Text>{village.taluka?.district?.name.gu}</Text>
						</Td>
						<Td>
							<Text fontWeight={500}>
								{village.taluka?.district?.state?.name?.en}
							</Text>
							<Text>{village.taluka?.district?.state?.name.gu}</Text>
						</Td>
						<Td>
							<Text fontWeight={500}>
								{village.taluka?.district?.state?.country?.name?.en}
							</Text>
							<Text>
								{village.taluka?.district?.state?.country?.name.gu}
							</Text>
						</Td>
						<Td>{formatDate(village.createdAt)}</Td>
						<Td>{formatDate(village.updatedAt)}</Td>
						<Td isNumeric>
							<EditIconButton onClick={() => onUpdate(village)} />
							<DeleteIconButton onClick={() => onDelete(village)} />
						</Td>
					</Tr>
				))}
			</Tbody>
		</Table>

		{list.map((village, i) => {
			return (
				<Card
					key={i}
					display={{ base: "flex", lg: "none" }}
					shadow={"md"}
					m={"2"}
				>
					<Box display={"flex"} justifyContent={"space-between"} m={"2"}>
						<Box alignItems={"center"}>
							<Flex>
								<Box fontWeight={"semibold"} fontSize={"md"}>
									Name:
								</Box>
								<Box ml={"2"}>{village.name.en}</Box>
							</Flex>
							<Flex align={"center"}>
								<Box fontWeight={"semibold"} fontSize={"md"}>
									Name Gujarati:
								</Box>
								<Box ml={"2"} fontSize={"sm"}>
									{village.name.gu}
								</Box>
							</Flex>
							<Flex align={"center"}>
								<Box fontWeight={"semibold"}>Taluka:</Box>
								<Box ml={"2"}>{village.taluka?.name?.en}</Box>
								<Box ml={"2"} fontSize={"sm"}>
									{village.taluka?.name?.gu}
								</Box>
							</Flex>
							<Flex align={"center"}>
								<Box fontWeight={"semibold"}>District:</Box>
								<Box ml={"2"}>{village.taluka?.district?.name?.en}</Box>
								<Box ml={"2"} fontSize={"sm"}>
									{village.taluka?.district?.name?.gu}
								</Box>
							</Flex>
							<Flex align={"center"}>
								<Box fontWeight={"semibold"}>State:</Box>
								<Box ml={"2"}>
									{village.taluka?.district?.state?.name?.en}
								</Box>
								<Box ml={"2"} fontSize={"sm"}>
									{village.taluka?.district?.state?.name?.gu}
								</Box>
							</Flex>
							<Flex align={"center"}>
								<Box fontWeight={"semibold"}>Country:</Box>
								<Box ml={"2"}>
									{village.taluka?.district?.state?.country?.name.en}
								</Box>
								<Box ml={"2"} fontSize={"sm"}>
									{village.taluka?.district?.state?.country?.name.gu}
								</Box>
							</Flex>
						</Box>
						<Box>
							<Flex>
								<EditIconButton onClick={() => onUpdate(village)} />
								<DeleteIconButton onClick={() => onDelete(village)} />
							</Flex>
						</Box>
					</Box>
				</Card>
			)
		})}
	</>
)
